import { inject, Injectable } from '@angular/core';
import { SelectorOption } from '../interfaces/form-and-field.interface';
import { SuggestionsHintsService } from '../services/suggestions-hints.service';

@Injectable()
export class AppPreloadingService {
  private suggestionsHintsService = inject(SuggestionsHintsService);

  public configureStaticAppData(): Promise<SelectorOption[][]> {
    return this.suggestionsHintsService.translateSuggestions();
  }
}
